export default __webpack_public_path__ + "images/4c68e4332bb36518fd820d7d23b916b7-camp.jpg";